
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { OnHoldReason } from 'enums/OnHoldReason';
import { LedgerPostModel } from './Entities.Accounting.LedgerPost';
import { Model, ModelProperty } from 'models/Model';


export class LedgerHeaderModel extends Model<LedgerHeaderModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'onHoldReason', type: 'OnHoldReason', languageString: 'ledgerHeader.property.onHoldReason' },
		{ name: 'registedInExternalAccountingSystem', type: 'boolean', languageString: 'ledgerHeader.property.registedInExternalAccountingSystem' },
		{ name: 'compactId', type: 'string', languageString: 'ledgerHeader.property.compactId' },
		{ name: 'id', type: 'guid', languageString: 'ledgerHeader.property.id', isHidden: true },
		{ name: 'draftDocumentNo', type: 'string', languageString: 'ledgerHeader.property.draftDocumentNo' },
		{ name: 'postedDocumentNo', type: 'string', languageString: 'ledgerHeader.property.postedDocumentNo' },
		{ name: 'postedDate', type: 'Date', languageString: 'ledgerHeader.property.postedDate' },
		{ name: 'dueDate', type: 'Date', languageString: 'ledgerHeader.property.dueDate' },
		{ name: 'closed', type: 'boolean', languageString: 'ledgerHeader.property.closed' },
		{ name: 'originalDueDate', type: 'Date', languageString: 'ledgerHeader.property.originalDueDate' },
		{ name: 'issuedReminderLevel', type: 'number', languageString: 'ledgerHeader.property.issuedReminderLevel' },
		{ name: 'brandId', type: 'guid', languageString: 'ledgerHeader.property.brandId' },
		{ name: 'overrideExternalDueDate', type: 'boolean', languageString: 'ledgerHeader.property.overrideExternalDueDate' },
		{ name: 'ledgerPosts', type: 'LedgerPostModel[]', languageString: 'ledgerHeader.property.ledgerPosts', isHidden: true, isArray: true, isObject: true, new: () => { return new LedgerPostModel }, properties: () => { return LedgerPostModel.classProperties } }
	];
	[key: string]: any;
	
	public onHoldReason?: OnHoldReason;
	public registedInExternalAccountingSystem: boolean;
	public compactId: string;
	public id?: string;
	public draftDocumentNo: string;
	public postedDocumentNo: string;
	public postedDate?: Date;
	public dueDate?: Date;
	public closed: boolean;
	public originalDueDate?: Date;
	public issuedReminderLevel?: number;
	public brandId?: string;
	public overrideExternalDueDate: boolean;
	public ledgerPosts: LedgerPostModel[];
    
	constructor(){
		super();
		this.onHoldReason = undefined;
		this.registedInExternalAccountingSystem = false;
		this.compactId = '';
		this.id = undefined;
		this.draftDocumentNo = '';
		this.postedDocumentNo = '';
		this.postedDate = undefined;
		this.dueDate = undefined;
		this.closed = false;
		this.originalDueDate = undefined;
		this.issuedReminderLevel = undefined;
		this.brandId = undefined;
		this.overrideExternalDueDate = false;
		this.ledgerPosts = [];
		
	}
	getProperties(){
		return LedgerHeaderModel.classProperties;
	}
}

